import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./Dropdrown";
import { useAppDispatch, useAppSelector } from "@/redux/hooks/hooks";
import { logOut } from "@/redux/feature/auth/authSlice";
import ActiveIcon from "@/assets/icons/ActiveUserIcon.svg";
import { Link, useNavigate } from "react-router-dom";
import { useGetMeQuery } from "@/redux/feature/user/userApi";

interface UserData {
  profileImg?: string;
  credits: number;
  fullName: string;
  email: string;
}

const UserDropDown = () => {
  const { user } = useAppSelector((state) => state.auth);
  const { data } = useGetMeQuery(user?.email);
  const userData: UserData | undefined = data?.data;

  const navigate = useNavigate();
  const name = userData?.fullName || "User";
  const dispatch = useAppDispatch();

  const handleLogout = () => {
    dispatch(logOut());
    navigate("/auth/sign-in");
  };
  const client_dashboard_baseUrl =
    import.meta.env.VITE_NODE_ENV === "development"
      ? import.meta.env.VITE_API_CLIENT_DASHBOARD_DEV
      : import.meta.env.VITE_NODE_ENV === "stage"
      ? import.meta.env.VITE_API_CLIENT_DASHBOARD_STAGE
      : import.meta.env.VITE_API_CLIENT_DASHBOARD_PROD;

  // User name slice based on name
  const getInitials = (fullName: string) => {
    const nameParts = fullName.split(" ");
    if (nameParts.length > 1) {
      return (
        nameParts[0].slice(0, 1) + nameParts[nameParts.length - 1].slice(0, 1)
      );
    }
    return nameParts[0].slice(0, 1);
  };

  const splitUserName = userData?.fullName
    ? getInitials(userData.fullName)
    : "";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        {userData?.profileImg ? (
          <div className="relative">
            <div className="w-10 h-10">
              <img
                className="w-full h-full rounded-full object-cover"
                src={userData.profileImg}
                alt="profile"
              />
            </div>
            <div className="absolute bottom-[0px] right-[0px]">
              <ActiveIcon />
            </div>
          </div>
        ) : (
          <div className="size-10 flex justify-center items-center text-[#17457D] rounded-full text-sm font-semibold leading-5 relative bg-[#17457D0F]">
            {splitUserName}
            <div className="absolute bottom-[0px] right-[0px]">
              <ActiveIcon />
            </div>
          </div>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {/* Header */}
        {/* <Link to={"/settings"}> */}
        <DropdownMenuItem>
          <div className="flex gap-2.5 items-center">
            <div>
              {userData?.profileImg ? (
                <div className="relative">
                  <div className="w-8 h-8">
                    <img
                      className="w-full h-full rounded-full object-cover"
                      src={userData.profileImg}
                      alt="profile"
                    />
                  </div>
                  <div className="absolute -bottom-[2px] -right-[3px]">
                    <ActiveIcon />
                  </div>
                </div>
              ) : (
                <div className="size-8 flex justify-center items-center text-[#17457D] rounded-full text-sm font-semibold leading-5 relative bg-[#17457D0F]">
                  {splitUserName}
                  <div className="absolute -bottom-[2px] -right-[3px]">
                    <ActiveIcon />
                  </div>
                </div>
              )}
            </div>
            <div>
              <h2 className="text-[14px] whitespace-nowrap font-medium">
                {userData?.fullName}
              </h2>
              <p className="text-[#98A2B3] truncate w-[150px] text-xs leading-3 font-normal">
                {userData?.email}
              </p>
            </div>
          </div>
        </DropdownMenuItem>
        {/* </Link> */}
        <DropdownMenuSeparator />
        {/* <DropdownMenuItem>
          <p className="text-sm leading-5 font-medium text-[#344054]">
            View Profile
          </p>
        </DropdownMenuItem> */}
        <DropdownMenuItem>
          <button
            onClick={() =>
              (window.location.href = `${client_dashboard_baseUrl}/settings`)
            }
            className="text-sm leading-5 font-medium text-[#344054]"
          >
            Settings
          </button>
        </DropdownMenuItem>
        <DropdownMenuItem>
          <button
            onClick={() =>
              (window.location.href = `${client_dashboard_baseUrl}/team`)
            }
            className="text-sm leading-5 font-medium text-[#344054]"
          >
            <p className="text-sm leading-5 font-medium text-[#344054]">Team</p>
          </button>
        </DropdownMenuItem>

        <DropdownMenuSeparator />
        {/* <DropdownMenuItem>
          <p
            className="text-caption-large font-semibold text-gray-800"
            onClick={handleLogout}
          >
            Sign Out
          </p>
        </DropdownMenuItem> */}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserDropDown;
